import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';

import * as AuthActions from './auth.actions';

@Injectable()
export class AuthEffects {
  persistTokens$ = createEffect(
    (actions$ = inject(Actions)): Observable<Action> =>
      actions$.pipe(
        ofType(AuthActions.setAccessToken, AuthActions.setRefreshToken),
        tap(action => {
          if ('accessToken' in action) {
            localStorage.setItem('accessToken', <string>action.accessToken);
          }
          if ('refreshToken' in action) {
            localStorage.setItem('refreshToken', <string>action.refreshToken || '');
          }
        })
      ),
    { dispatch: false }
  );

  clearTokensOnLogout$ = createEffect(
    (actions$ = inject(Actions)): Observable<Action> =>
      actions$.pipe(
        ofType(AuthActions.logout),
        tap(() => {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
        })
      ),
    { dispatch: false }
  );
}
